import {createAsyncThunk} from '@reduxjs/toolkit';
import {itemsApi} from 'api';
import {toastNotificationManager} from 'toast-notifications';
import {itemsMessages} from '../../utils';
import {prefix} from './config';

export const publishAllAnswerStacksForQuestionThunk: any = createAsyncThunk<any, number>(
  `${prefix} publishAllAnswerStacksForQuestion`,
  async (questionId: number, {dispatch, rejectWithValue}) => {
    try {
      const {parsedBody} = await itemsApi.publishAllAnswerStacksForQuestion(questionId);
      dispatch(toastNotificationManager.createSuccessToastAction(itemsMessages.publishAllSuccess));
      return parsedBody;
    } catch (err) {
      dispatch(toastNotificationManager.createErrorToastAction(err.parsedBody));
      return rejectWithValue({error: err});
    }
  }
);
